import React from 'react';
import {node, string, oneOf} from 'prop-types';
import classNames from 'classnames';
import styles from './Flag.css';

const Flag = ({children, className, displayType}) => (
  <em
    className={classNames(
      className,
      styles.Flag,
      {[styles[displayType]]: Boolean(displayType)}
    )}
  >
    {children}
  </em>
);

Flag.defaultProps = {
  className: '',
  displayType: '',
};

Flag.propTypes = {
  children: node.isRequired,
  className: string,
  displayType: oneOf(['', 'info', 'success']),
};

export default Flag;
